// Actions
import {
  APP_SET_APPLICATION,
  APP_SET_LANGUAGE,
  APP_SET_THEME,
  APP_SET_UNIT_SYSTEM,
} from '../actionTypes';

export const initialState = {
  theme: 'default',
  unitSystem: null,
  language: null,
  application: {},
};

export default (state = { ...initialState }, action) => {
  switch (action.type) {
    case APP_SET_THEME:
      return {
        ...state,
        theme: action.payload,
      };
    case APP_SET_UNIT_SYSTEM:
      return {
        ...state,
        unitSystem: action.payload,
      };
    case APP_SET_LANGUAGE:
      return {
        ...state,
        language: action.payload,
      };
    case APP_SET_APPLICATION:
      return {
        ...state,
        application: action.payload,
      };
    default:
      return state;
  }
};
